setTimeout(() => {
    const miniCartButton = document.querySelector('.yv-side-drawer-container')
    if (miniCartButton) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    setTimeout(() => {
                        BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
                    }, 1500)

                    function handleButtonClick(e) {
                        e.preventDefault();
                        const $button = $(this);
                        let oldText = $(this).text();
                        $button.css({
                            'pointer-events': 'none',
                            'opacity': '0.6'
                        });
                        $button.text("Loading ...");
                        setTimeout(() => {
                            $button.css({
                                'pointer-events': 'unset',
                                'opacity': '1'
                            })
                            $button.text(oldText);
                        }, 2000);
                    }

                    $(document).on('click dblclick', '.cart-btn-container a', handleButtonClick);
                }
            });
        });
        observer.observe(miniCartButton, {
            childList: true
        });
    }
    if (window.location.pathname.includes("/cart")) {
        function handleCheckout() {
           
            const cartButton = document.querySelectorAll('.quantity-button')
            cartButton.forEach(e => {
                e.addEventListener('click', () => {
                   $('button[name="checkout"]').css("pointer-events", "none")
                    setTimeout(() => {
                      
                        BSS_B2B.observer.cartSubject.listenCartCheckout()
                        handleCheckout()
                    }, 1500)
                    setTimeout(() => {
   $('button[name="checkout"]').css("pointer-events", "unset")
                     
                    }, 2000)
                })
            })
        }
        handleCheckout()
    }
}, 2000)
if (window.BSS_BCP_V2?.productPage) {
BSS_BCP_V2.productPage.addCartSelectors = [".add_to_cart"];
BSS_BCP_V2.productPage.productInfoSelectors = [".yv-main-product-detail"];
}